// Interface copy with room for a voice: the lines on the final card. The
// cue bar's lines stay in src/game/cue.ts because they are instructions.
// This file belongs to the writing, like src/content/cards.ts.

export const END_CARD = {
  /** Under "Sun wins" when the player won. */
  playerWon: 'You win the match.',
  /** Under "Moon wins" when the player lost. */
  playerLost: 'Moon wins the match.',
  /** Under "Nobody wins". */
  draw: 'Both crowns fell at once.',
} as const;
